// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const kyurem: PokeData = {
  "id": 646,
  "name": "kyurem",
  "height": 30,
  "weight": 3250,
  "base_experience": 297,
  "types": [
    PokeType.DRAGON,
    PokeType.ICE
  ],
  "api_moves": [
    "ice-beam",
    "blizzard",
    "dragon-rage",
    "slash",
    "scary-face",
    "icy-wind",
    "outrage",
    "dragon-breath",
    "ancient-power",
    "endeavor",
    "imprison",
    "hyper-voice",
    "sheer-cold",
    "dragon-pulse",
    "glaciate",
    "noble-roar",
    "freeze-dry"
  ],
  "moves": [
    "blizzard",
    "scary-face",
    "outrage",
    "dragon-breath",
    "ancient-power",
    "hyper-voice",
    "sheer-cold",
    "dragon-pulse",
    "inner-spirit",
    "ice-shard",
    "great-roar",
    "dragon-vortex",
    "ice-fang"
  ],
  "evolution_chain": {
    "id": 333,
    "item": null,
    "species": [
      {
        "name": "kyurem",
        "order": 647,
        "types": [
          PokeType.DRAGON,
          PokeType.ICE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 129,
    "speed": 114,
    "ability_power": 156
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
